import supportIndexJson from '../generated/support-index.json';
import { HOME_ASSISTANT_ARTICLE_ID, homeAssistantArticleMetadata } from '../content/support/homeAssistantArticleMeta';

interface SupportMetaArticle {
  audience: 'consumer' | 'pro';
  id: string;
  title: string;
  canonical_path: string;
  excerpt: string;
}

const supportArticles = (supportIndexJson.articles as SupportMetaArticle[]).map(article => article.id === HOME_ASSISTANT_ARTICLE_ID
  ? { ...article, ...homeAssistantArticleMetadata }
  : article);

export const getSupportArticleMeta = (path: string) => {
  const match = path.match(/^\/support(?:\/pro)?\/articles\/(\d+)/);
  const article = match
    ? supportArticles.find(candidate => candidate.id === match[1])
    : null;

  if (!article) return null;

  return {
    title: `${article.title} | ${article.audience === 'pro' ? 'HAVEN Pro Support' : 'HAVEN Support'}`,
    description: article.excerpt,
    canonicalPath: article.canonical_path,
    ogType: 'article' as const,
  };
};
